module.exports = "<div>{{PrinterServiceData?.reportID}}</div>\n<div *ngIf=\"PrinterServiceData?.iframeUrl\">\n    <lfwms-iframe [iframeUrl]=\"iframeUrl\" [width]=\"width\" [height]=\"height\"></lfwms-iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/jreport/jreport-print/jreport-print.component.html
// module id = ../../../../../src/app/shared/jreport/jreport-print/jreport-print.component.html
// module chunks = main